<template>
	<LazyHydrate :ssr-only="true">
		<SubComponent :chronic-id="chronicId" />
	</LazyHydrate>
</template>

<script>
import SubComponent from './Module.vue';
import LazyHydrate from './LazyHydrate.vue';

export default {
	components: {
		SubComponent,
		LazyHydrate,
	},
	props: {
		chronicId: {
			type: String,
			required: true,
		},
	},
};
</script>
